"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PropTypes = __importStar(require("prop-types"));
const react_1 = require("react");
const clsx_1 = require("clsx");
const prefix = 'tk-expandable-card';
const buildClass = (classStr) => `${prefix}__${classStr}`;
const ExpandableCard = (_a) => {
    var { children, className, header, initCollapsed, onToggle } = _a, rest = __rest(_a, ["children", "className", "header", "initCollapsed", "onToggle"]);
    const [collapsed, setCollasped] = (0, react_1.useState)(initCollapsed === undefined || initCollapsed);
    const [refEl, setRefEl] = (0, react_1.useState)(null);
    const onToggleHeader = () => {
        const reverseCollapsed = !collapsed;
        setCollasped(reverseCollapsed);
        if (onToggle) {
            onToggle(reverseCollapsed, refEl);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.clsx)(prefix, className), ref: setRefEl }, rest, { children: [(0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.clsx)(buildClass('header')), children: [(0, jsx_runtime_1.jsx)("div", { children: header }), "\u2022", (0, jsx_runtime_1.jsx)("a", { className: (0, clsx_1.clsx)('tk-link toggle'), onClick: onToggleHeader, children: collapsed ? 'EXPAND' : 'COLLAPSE' }), (0, jsx_runtime_1.jsx)("i", { className: (0, clsx_1.clsx)('tk-icon-top', { collapsed }), onClick: onToggleHeader, "aria-label": "Toggle" })] }), (0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)(buildClass('body'), { collapsed }), children: children })] })));
};
ExpandableCard.propTypes = {
    initCollapsed: PropTypes.bool,
    header: PropTypes.node.isRequired,
};
ExpandableCard.defaultProps = {
    initCollapsed: true,
};
exports.default = ExpandableCard;
